import React from 'react';
import useDarkMode from 'use-dark-mode';

const DarkMode = () => {
    const darkMode = useDarkMode(false);
    return (<div>
        <button className="toggle-button" onClick={darkMode.toggle}>{darkMode.value ? "☾" : "☼"}</button>
    </div >)
}

export default DarkMode;